import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
//import { GETMETHODREAD } from '../axiosComponent/read';
import allAxiosCommonRequest from "../axiosComponent/allAxiosCommonRequest";

const MyBusinessType = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    useEffect(() => {
        // $("#searchType .dropdown").removeClass("dropdown")
        setloading(true)
        allAxiosCommonRequest({
            url: "transporter-allocation/orders/masters/load/type",
            method: "get",
        })//CommonGetApi({ url: 'branch' })
            .then((data) => {
                let loadtypeRes = data.data.data

                if (localStorage.getItem('customerNumber') == 549) {
                    loadtypeRes.forEach(element => {
                        if (element.load_type_name == "Frozen") {
                            element.load_type_name = 'Reefer'
                        }
                    });
                    let newLoadType = loadtypeRes.filter((type) => {
                        if (type.load_type_name == "Reefer" || type.load_type_name == "Dry") {
                            return type
                        }
                    })

                    setcontent(newLoadType)
                }
                else {
                    setcontent(loadtypeRes)
                }

                setloading(false)
            }).catch((error) => console.log(error))

        /* GETMETHODREAD({
            newUrl: 'transporter-allocation/orders/masters/load/type',
            response: ((data) => {
                let cont = data.data.data
                setcontent(cont)
                setloading(false)
            })
        }) */
    }, [])
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.load_type_id
            temp.text = `${object.load_type_name}`
            temp.value = object.load_type_name.toLowerCase()
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
    }
    return (
        <Dropdown
            selection
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyBusinessType